/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Teams_Stats_Teams_CountInputs */



/**
* | output |
* | --- |
* | "{count} Teams" |
*
* @param {Teams_Stats_Teams_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const teams_stats_teams_count = /** @type {((inputs: Teams_Stats_Teams_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teams_Stats_Teams_CountInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Teams`)
	return /** @type {LocalizedString} */ (`${i?.count} Teams`)
});